<template>
  <v-dialog
    v-model="display"
    :width="width"
    @click:outside="close"
  >
    <v-card density="compact">
      <v-card-title class="text-h6 prompt-title-bar lighten-2">
        <!-- <v-row class="pt-0 pb-0">
          <v-col cols="9" class="text-left">
            <v-icon v-if="icon != ''" color="white">
              {{icon}}
            </v-icon>
            {{ title }}
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="1" class="text-center">
            <v-icon color="white" @click="close">
              mdi-close
            </v-icon>
          </v-col>
        </v-row> -->

        <v-row class="pt-0 pb-0 position-relative align-center justify-center" style="height: 40px; display: flex; align-items: center">
          <!-- Centered content -->
          <div style="margin-top: -4px">
            <v-icon v-if="icon != ''" color="white" size="20">
                {{ icon }}
            </v-icon>
            <span style="font-size: 14px !important; margin: 0; padding: 0">{{ title }}</span>
          </div>
          

          <div style="position: absolute; right: 8px; top: 2px">
            <v-icon color="white" @click="close">
              mdi-close
            </v-icon>
          </div>
        </v-row>
        
        
      </v-card-title>
      <br>
      <v-card-text class="prompt-text">
        <slot></slot>
      </v-card-text>
    
      <v-card-text 
        v-if="res" 
        class="status-message"
        >
        <div :class="res.code">{{ res.msg }}</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    display: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    state: {
      type: Boolean,
      required: false,
      default: () => true
    },
    res: {
      type: Object,
      required: false,
      default: () => {}
    },
    width: {
      type: Number,
      required: false,
      default: () => 600
    },
    icon: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      finished: false
    }
  },
  watch: {
    state() {
      if(this.state) {
        this.loading = false;
        this.finished = true;
      }
    }
  },
  mounted() {
    this.dialog = this.display;
  },
  methods: {
    close() {
      this.finished = false;
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
  .prompt-title-bar {
    background: #0f74bb;
    color: white;
  }
  .prompt-text {
    font-size: 1em;
    overflow: hidden;
  }
  .status-message {
    text-align: center;
    font-size: 1em;
  }
  .green {
    color: green !important;
    background-color: white !important;
  }
  .red {
    color: red !important;
    background-color: white !important;
  }
  .close-icon {
    position: absolute;
    right: 0;
  }
</style>